import styled from "styled-components";
import { colors } from "../../components/helpers/functions";

export const WrapperStyled = styled.div`
    background-color: rgba(${colors.blanco_huevo}, 1);
    border-bottom: 7px solid rgba(${colors.marron_tierra}, 1);
    p{
        padding: 0;
        margin: 0;
    }
    .content{
        padding: 7vw 9vw;
        display: flex;
        flex-direction: column;
        justify-content: center;
        
        .title{
            display: flex;
            //text-align: center;
            font-size: 12vw;
            line-height: 12vw;
            font-weight: 900;
            color: #309837;//rgba(${colors.azul_agua}, 1);
        }
        .items{
            display: flex;
            flex-direction: column;
            margin-top: 7vw;
            .item{
                display: flex;
                flex-direction: row;
                align-items: center;
                margin-bottom: 10px;
                padding-left: 0.7vw;
                .trebol{
                    width: 30px;
                }
                .icon{
                    display: flex;
                    font-size: 25px;
                    line-height: 25px;
                    margin-left: 10px;
                    padding-bottom: 5px;
                    .pending{
                        display: flex;
                        padding-bottom: 4px;
                        color: rgba(${colors.marron_tierra}, 1);
                    }
                    .complete{
                        display: flex;
                        color: #309837;//rgba(${colors.verde_acelga}, 1);
                    }
                }
                .name{
                    font-size: 18px;
                    line-height: 18px;
                    font-weight: 800;
                    text-transform: uppercase;
                    margin-left: 10px;
                    padding-bottom: 5px;
                    color: rgba(${colors.blanco_huevo}, 1);
                    //color: rgba(${colors.marron_tierra}, 1);
                    &.pending{
                        color: rgba(${colors.marron_tierra}, 1);
                    }
                    &.complete{
                        color: #309837;//rgba(${colors.verde_acelga}, 1);
                    }
                }
                
                &:last-child{
                    margin-bottom: 0;
                }
            }
        }
        .p1{
            color: rgba(${colors.marron_tierra}, 1);
            font-size: 4vw;
            line-height: 5.2vw;
            font-weight: 500;
            padding-left: 0.7vw;
            margin-top: 1vw;
            .destaca{
                font-weight: 700;
                //color: rgba(${colors.verde_acelga}, 1);
            }
        }
        .p2{
            color: rgba(${colors.marron_tierra}, 1);
            font-size: 4vw;
            line-height: 5.2vw;
            font-weight: 500;
            padding-left: 0.7vw;
            .destaca{
                font-weight: 700;
                //color: rgba(${colors.verde_acelga}, 1);
            }
        }
    }
    .text_trebol{
        font-weight: 700;
        color: rgba(${colors.trebol}, 1);
    }
    .box_fin{
        border-top: 1px solid rgba(${colors.trebol}, 1);
        border-bottom: 1px solid rgba(${colors.trebol}, 1);
        padding-top: 5vw;
        padding-bottom: 5vw;
        margin-top: 5vw;
    }
`